import { useCallback, useEffect } from "react";
import { useAppGlobStore } from "src/appGlobalStore";
import { DomUtil } from "src/util/DomUtil";

export interface FullScreen {
  isFullScreen: boolean;
  toggle: () => void;
}

export function useFullScreen(): FullScreen {
  const showMenu = useAppGlobStore(s => s.showMenu);
  const isMobile = useAppGlobStore(s => s.isMobile);
  const closeDesktopLeftTree = useAppGlobStore(s => s.closeDesktopLeftTree);
  const openDesktopLeftTree = useAppGlobStore(s => s.openDesktopLeftTree);

  const toggle = useCallback(() => {
    DomUtil.animateMenu();
    useAppGlobStore.setState(state => ({ showMenu: !state.showMenu }));
    if (showMenu)
      closeDesktopLeftTree();
    else if (!isMobile)
      openDesktopLeftTree();
  }, [showMenu, isMobile, closeDesktopLeftTree, openDesktopLeftTree]);

  return { isFullScreen: !showMenu, toggle };
}

/** Brings the left and top menu back. */
export function exitFullScreen(): void {
  const { showMenu, isMobile, openDesktopLeftTree } = useAppGlobStore.getState();
  if (showMenu)
    return;

  DomUtil.animateMenu();
  useAppGlobStore.setState({ showMenu: true });
  if (!isMobile)
    openDesktopLeftTree();
}

/** @param keep asked at unmount - true leaves the menu hidden */
export function useExitFullScreenOnLeave(keep?: () => boolean): void {
  useEffect(() => () => {
    if (!keep?.())
      exitFullScreen();
  }, []);
}

export default useFullScreen;
